import { create } from 'zustand';

/**
 * 웹뷰타입
 * - main: 메인 웹뷰
 * - v3: Shift 웹뷰
 * - v4: Uplift 웹뷰
 * - search: 검색 (미정)
 */
export type WebviewType = 'main' | 'v3' | 'v4' | 'search';

/**
 * 웹뷰 상태
 * - idle:
 * - active:
 * - inactive:
 */
export type WebviewStatus = 'idle' | 'active' | 'inactive';

interface WebviewContextState {
    webviewId: string | null;
    webviewType: WebviewType | null;
    status: WebviewStatus;
    statusBarColor?: '0' | '1'; //상태바 color
    initialized: boolean;

    /**
     * 웹뷰 정보를 설정한다.
     * @param param 웹뷰정보
     * @returns
     */
    setWebview: (param: { webviewId: string; webviewType: WebviewType }) => void;

    /**
     * 웹뷰 상태를 설정한다.
     * @param status 웹뷰 상태
     * @returns
     */
    setStatus: (status: WebviewStatus) => void;

    setStatusBarColor: (color: '0' | '1') => void;

    /**
     * 웹뷰 초기화여부 설정을 한다.
     * @param initialized 초기화 여부
     * @returns
     */
    setInitialized: (initialized: boolean) => void;

    /**
     * 웹뷰 resume 처리
     * @returns
     */
    resume: () => void;

    /**
     * 현재 웹뷰 활성화 여부를 가져온다.
     * @returns
     */
    isActive: () => boolean;
}

/**
 * 현재 웹뷰정보 관리 전역 Store
 */
export const useWebviewContextStore = create<WebviewContextState>((set, get) => ({
    webviewId: null,
    webviewType: null,
    status: 'idle',
    initialized: false,
    setWebview: ({ webviewId, webviewType }) => {
        set({
            webviewId,
            webviewType,
        });
    },

    setStatus: (status: WebviewStatus) => {
        set({
            status,
        });
    },

    setStatusBarColor: (statusBarColor: '0' | '1') => {
        set({
            statusBarColor,
        });
    },

    setInitialized: (initialized: boolean) => {
        set({
            initialized,
        });
    },

    resume: () => {
        set({
            status: 'active',
        });
    },

    isActive: () => get().status === 'active',
}));
